export default {
	URL: 'https://api-criatec.infinitum-ti.com',
	API_URL: 'https://api-criatec.infinitum-ti.com/api',
	OAPI_URL: 'https://api-criatec.infinitum-ti.com/oapi',
	// URL: 'http://localhost:2394',
	// API_URL: 'http://localhost:2394/api',
	// OAPI_URL: 'http://localhost:2394/oapi',
}
